import React from 'react';
import PropTypes from 'prop-types';
// graphQL
import gql from 'graphql-tag';
// our components
import Paginator from './Paginator';

/**
 * Fragment to fetch PageInfo
 */
export const CustomPageInfo = gql`
  fragment PaginatorCustomPageInfo on CustomPageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
`;

export const PageInfo = gql`
  fragment PaginatorPageInfo on PageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
`;

/**
 * @class
 * @extends React.Component
 */
class PaginatorContainer extends React.Component {
  /**
   * @description
   * Set variables to pagination and exec callback.
   *
   * @param {string} direction - Direction to change page.
   */
  handleChangePage = direction => {
    const { pageInfo, changePage } = this.props;
    if (direction === 'NEXT') {
      changePage({ direction, cursor: pageInfo.endCursor });
    } else {
      changePage({ direction, cursor: pageInfo.startCursor });
    }
  };

  /**
   * @description
   * Exec callbacks to change number of rows selected and update data.
   *
   * @param {number} selectedItem - New number of rows selected.
   */
  handleChangeNumberOfRows = selectedItem => {
    const { changeNumberOfRows } = this.props;
    changeNumberOfRows(selectedItem);
  };

  /**
   * @description
   * Render Paginator component.
   */
  render() {
    const {
      numberOfRowsSelected,
      pageInfo,
      paginationDirection,
      queryCount,
    } = this.props;
    return (
      <Paginator
        changePage={this.handleChangePage}
        queryCount={queryCount}
        changeNumberOfRows={this.handleChangeNumberOfRows}
        numberOfRowsSelected={numberOfRowsSelected}
        nextDisabled={
          (!paginationDirection || paginationDirection === 'NEXT') &&
          !pageInfo.hasNextPage
        }
        prevDisabled={
          !paginationDirection ||
          (paginationDirection === 'PREVIOUS' && !pageInfo.hasPreviousPage)
        }
      />
    );
  }
}

/**
 * Paginator PropTypes
 * @param pageInfo - prop current page info information
 * @param numberOfRowsSelected - prop to pass Paginator
 * @param queryCount - total query count
 * @callback changePage - callback to pass Paginator
 * @callback changeNumberOfRows - callback to pass Paginator
 */

PaginatorContainer.propTypes = {
  pageInfo: PropTypes.instanceOf(Object).isRequired,
  changePage: PropTypes.func.isRequired,
  changeNumberOfRows: PropTypes.func.isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  queryCount: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  paginationDirection: PropTypes.string,
};

PaginatorContainer.defaultProps = {
  queryCount: null,
};

export default PaginatorContainer;
